const participantRole = {
  REQUESTING: 'REQUESTING',
  CONTESTED: 'CONTESTED'
};

module.exports = participantRole;
